/* tslint:disable */
/* eslint-disable */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { IStepUsageColumn } from '../models';
// @ts-ignore
import type { ISystemStepConfiguration } from '../models';
/**
 * ConstructionSystemApi - axios parameter creator
 */
export const ConstructionSystemApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} siteId 
         * @param {string} [siteTaskId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDataUsageColumns: async (siteId: number, siteTaskId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'siteId' is not null or undefined
            assertParamExists('getDataUsageColumns', 'siteId', siteId)
            const localVarPath = `/api/system/getDataUsageColumns`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (siteId !== undefined) {
                localVarQueryParameter['siteId'] = siteId;
            }

            if (siteTaskId !== undefined) {
                localVarQueryParameter['siteTaskId'] = siteTaskId;
            }

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPossibleSystemSteps: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/system/getPossibleSystemSteps`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} siteId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSystemIdsForSite: async (siteId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'siteId' is not null or undefined
            assertParamExists('getSystemIdsForSite', 'siteId', siteId)
            const localVarPath = `/api/system/getSystemIdsForSite`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (siteId !== undefined) {
                localVarQueryParameter['siteId'] = siteId;
            }

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ConstructionSystemApi - functional programming interface
 */
export const ConstructionSystemApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ConstructionSystemApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} siteId 
         * @param {string} [siteTaskId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDataUsageColumns(siteId: number, siteTaskId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<IStepUsageColumn>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDataUsageColumns(siteId, siteTaskId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ConstructionSystemApi.getDataUsageColumns']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPossibleSystemSteps(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ISystemStepConfiguration>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPossibleSystemSteps(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ConstructionSystemApi.getPossibleSystemSteps']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} siteId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSystemIdsForSite(siteId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<string>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSystemIdsForSite(siteId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ConstructionSystemApi.getSystemIdsForSite']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ConstructionSystemApi - factory interface
 */
export const ConstructionSystemApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ConstructionSystemApiFp(configuration)
    return {
        /**
         * 
         * @param {number} siteId 
         * @param {string} [siteTaskId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDataUsageColumns(siteId: number, siteTaskId?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<IStepUsageColumn>> {
            return localVarFp.getDataUsageColumns(siteId, siteTaskId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPossibleSystemSteps(options?: RawAxiosRequestConfig): AxiosPromise<Array<ISystemStepConfiguration>> {
            return localVarFp.getPossibleSystemSteps(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} siteId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSystemIdsForSite(siteId: number, options?: RawAxiosRequestConfig): AxiosPromise<Array<string>> {
            return localVarFp.getSystemIdsForSite(siteId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ConstructionSystemApi - interface
 */
export interface ConstructionSystemApiInterface {
    /**
     * 
     * @param {number} siteId 
     * @param {string} [siteTaskId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getDataUsageColumns(siteId: number, siteTaskId?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<IStepUsageColumn>>;

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getPossibleSystemSteps(options?: RawAxiosRequestConfig): AxiosPromise<Array<ISystemStepConfiguration>>;

    /**
     * 
     * @param {number} siteId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getSystemIdsForSite(siteId: number, options?: RawAxiosRequestConfig): AxiosPromise<Array<string>>;

}

/**
 * ConstructionSystemApi - object-oriented interface
 */
export class ConstructionSystemApi extends BaseAPI implements ConstructionSystemApiInterface {
    /**
     * 
     * @param {number} siteId 
     * @param {string} [siteTaskId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getDataUsageColumns(siteId: number, siteTaskId?: string, options?: RawAxiosRequestConfig) {
        return ConstructionSystemApiFp(this.configuration).getDataUsageColumns(siteId, siteTaskId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getPossibleSystemSteps(options?: RawAxiosRequestConfig) {
        return ConstructionSystemApiFp(this.configuration).getPossibleSystemSteps(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} siteId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getSystemIdsForSite(siteId: number, options?: RawAxiosRequestConfig) {
        return ConstructionSystemApiFp(this.configuration).getSystemIdsForSite(siteId, options).then((request) => request(this.axios, this.basePath));
    }
}

